import { isEmpty } from 'lodash';

export function isAssetValid(value?: string | null): boolean {
  return !isEmpty(value);
}

export function isSpotValid(value?: string | null): boolean {
  return !isEmpty(value);
}

export function isAreaValid(value?: string | null): boolean {
  return !isEmpty(value);
}

export function isCategoryValid(value?: string | null): boolean {
  return !isEmpty(value);
}
